import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesIdentityDocumentPhotoComponent} from "./sales-identity-document-photo.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {WebcamModule} from "ngx-webcam";



@NgModule({
  declarations: [
    SalesIdentityDocumentPhotoComponent,
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule,
    WebcamModule

  ],
  exports: [
    SalesIdentityDocumentPhotoComponent
  ]
})
export class SalesIdentityDocumentPhotoModule { }
